import React, { useEffect, useState } from "react";
// import hover from "../../src/assets/images/webchatbot/mascot/hover.gif";
import hover from "../../src/assets/images/webchatbot/mascot/hover.png";
import over from "../../src/assets/images/webchatbot/mascot/over.gif";
import start from "../../src/assets/images/webchatbot/mascot/Start.gif";

const WidgetIcon = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = () => {
    setIsClicked(true);

    setTimeout(() => {
      window.parent.postMessage("openWidget", "*");
      setIsClicked(false);
    }, 1200);
  };
  return (
    <>
      <div
        id="gif-container"
        className={`gif-container active`}
        style={{ animation: "surfing-motion 1.5s ease-out forwards" }}
      >
        <div className="eye-catcher">
          Hi! I am Kineto, how can I help you today?{" "}
        </div>
        <div
          style={{ width: "150px", height: "170px" }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
        >
          <img
            className={`default ${isClicked || isHovered ? "hidden" : "active"}`}
            id="defaultGif"
            src={start}
            alt="Default GIF"
          />
          <img
            className={`hover ${isHovered && !isClicked ? "active" : "hidden"}`}
            id="hoverGif"
            src={hover}
            alt="Hover GIF"
          />
          <img
            className={`over ${isClicked ? "active" : "hidden"}`}
            id="overGif"
            src={over}
            alt="Over GIF"
          />
        </div>
      </div>
    </>
  );
};

export default WidgetIcon;
